<template>
  <SearchContainer @search="search">
    <template slot="default">
      <span class="required-fields">
        {{ $t("pages.details.requiredFields") }}
      </span>
      <div class="row">
        <div class="col-12 col-sm-4 d-flex">
          <card divider>
            <div class="d-flex">
              <div class="d-flex flex-column pr-2">
                <HorizontalDetailTitle
                  :label="$t('sections.logs.search.start')"
                />
                <HorizontalDetailTitle
                  :label="$t('sections.logs.search.end')"
                  :valid="validEndTime"
                />
              </div>
              <div class="d-flex flex-column flex-fill">
                <HorizontalDetailInput
                  type="datetime"
                  :field="query.startDate"
                  :valid="validStartTime"
                  :edit="true"
                  :errorLabel="
                    $t('components.horizontalInput.invalidStartDate')
                  "
                  @input="(e) => onInput('startDate', e)"
                />
                <HorizontalDetailInput
                  type="datetime"
                  :field="query.endDate"
                  :valid="validEndTime"
                  :edit="true"
                  :errorLabel="$t('components.horizontalInput.invalidEndDate2')"
                  @input="(e) => onInput('endDate', e)"
                />
              </div>
            </div>
            <span class="required-fields">
                {{ $t("sections.logs.search.intervals") }}
              </span>
          </card>
        </div>
        <div class="col-sm-3">
          <Input
            type="text"
            :label="$t('sections.logs.search.locationId')"
            :field="query.id"
            @input="(e) => onInput('id', e)"
          />
        </div>
        <div class="col-sm-3">
          <Input
            type="dropdown"
            :label="$t('sections.logs.search.messageType')"
            :items="$t('messagesType')"
            :field="query.messageType"
            @input="(e) => onInput('messageType', e)"
          />
        </div>
        <div class="col-sm-2">
          <el-button
            type="primary"
            @click="search"
            v-bind:disabled="!validFields"
            class="mb-3"
          >
            <font-awesome-icon
              icon="fa-regular fa-magnifying-glass"
              class="mr-2"
            />
            {{ $t("sections.common.search.searchButton") }}
          </el-button>
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'LogsOCPPSearchOptions',
  components: {
    SearchContainer,
    HorizontalDetailTitle,
    HorizontalDetailInput,
    Input,
  },
  data() {
    return {
      query: {
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
        id: '',
        messageType: '',
      },
    };
  },
  computed: {
    validSearch() {
      // TODO check required fields
      return true;
    },
    validEndTime() {
      if (this.query.endDate) return true;
      return false;
    },
    validStartTime() {
      if (this.query.startDate && this.query.endDate >= this.query.startDate) return true;

      return false;
    },

    validFields() {
      return (
        this.validEndTime
        && this.validStartTime
        && this.query.startDate
        && this.query.endDate
      );
    },
  },
  methods: {
    onInput(field, value) {
      if (
        field === 'startDate'
        && value !== null
        && this.query.endDate
          >= new Date(value.getTime() + 7 * 24 * 60 * 60 * 1000)
      ) {
        this.query.endDate = new Date(
          value.getTime() + 7 * 24 * 60 * 60 * 1000,
        );
      }
      if (
        field === 'endDate'
        && value !== null
      ) {
        this.query.startDate = new Date(
          value.getTime() - 7 * 24 * 60 * 60 * 1000,
        );
      }
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
        id: '',
        messageType: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped>
.options-container {
  --input-label-width: 90px;
}
</style>
